import React, { PropTypes } from 'react';
import { reduxForm, Field, initialize, SubmissionError } from 'redux-form';
import InputControl from '../../FormTemplate/InputControl';
import Select from '../../FormTemplate/Select';
import { Button, ButtonGroup } from 'react-bootstrap';
import axios from './../../../constants/axios';
import alert from 'alertify.js';

@reduxForm({
   form: 'contactGeneralEditForm'
})
class ContactGeneralEditForm extends React.Component {

   constructor(props) {
      super(props);
      this.state = {
         contactTypes: []
      };
   }

   componentDidMount() {
      axios.get('contactTypes')
         .then((res) => {
            let n = res.data.map(function (i) {
               return {
                  label: i.name,
                  value: i.id
               };
            });
            this.setState({
               contactTypes: n
            });
         });
      this.props.dispatch(initialize('contactGeneralEditForm', this.props.general));
   }

   update = (inputs) => {
      const { contactTypes } = this.state;
      return axios.put('contacts/putGeneral', inputs)
         .then((res) => {
            if (res.status === 204) {
               const { updateGeneral } = this.props;
               const indexOfContactTypes = contactTypes.findIndex((cType) => {
                  return cType.value === inputs.contact_type_id;
               });
               if (indexOfContactTypes > -1) {
                  inputs = Object.assign({}, inputs, {
                     contact_type: contactTypes[indexOfContactTypes].label
                  });
               }
               updateGeneral(inputs);
               alert.success('Update Successful.');
            } else {
               alert.error('UnExpected error. Call Admin.');
            }
         })
         .catch((err) => {
            if (err.response.status === 422) {
               throw new SubmissionError(err.response.data);
            } else {
               alert.error('UnExpected error. Call Admin.');
            }
         });
   };

   render() {
      const { handleSubmit, submitting, pristine, invalid, toggleShowForm } = this.props;
      const { contactTypes } = this.state;
      return (
         <div>
            <h4>Contact General Edit Form</h4>
            <hr/>
            <form noValidate autoComplete="off" onSubmit={handleSubmit(this.update)} >
               <Field name="id" component="input" type="hidden" />
               <Field name="name" component={InputControl} label="Contact Name" />
               <Field name="mobile" component={InputControl} label="Contact Mobile" />
               <Field name="email" component={InputControl} label="Contact Email" />
               <Field name="contact_type_id" component={Select} options={contactTypes} label="Contact Type" />

               <label>
                  <Field name="active" component="input" type="checkbox" />
                  {" "}
                  Active
               </label>
               <hr/>

               <ButtonGroup>
                  <Button type="submit" bsStyle="success"
                          disabled={submitting || pristine || invalid} >Update</Button>
                  <Button onClick={toggleShowForm} >Cancel</Button>
               </ButtonGroup>
            </form>
         </div>
      );
   }
}
ContactGeneralEditForm.propTypes = {
   handleSubmit: PropTypes.func,
   params: PropTypes.object,
   general: PropTypes.object,
   submitting: PropTypes.bool,
   pristine: PropTypes.bool,
   invalid: PropTypes.bool,
   dispatch: PropTypes.func,
   updateGeneral: PropTypes.func,
   toggleShowForm: PropTypes.func,
};

export default ContactGeneralEditForm;



/** WEBPACK FOOTER **
 ** ./src/components/Contact/ContactDetail/ContactGeneralEditForm.js
 **/